import React from "react";

const Spinner = () => {
    return (
        <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0a0a0a' }}>
            <div className="w-64 h-2 bg-gray-700 rounded-full overflow-hidden">
                <div
                    className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full"
                    style={{
                        width: '100%',
                        animation: 'progress 6s ease-in-out infinite'
                    }}
                ></div>
            </div>

            {/* CSS Animations */}
            <style jsx>{`
                @keyframes progress {
                    0% { width: 0%; }
                    50% { width: 100%; }
                    100% { width: 0%; }
                }
            `}</style>
        </div>
    );
};

export default Spinner;